import { mediaUrl } from "@/lib/api";
import StorefrontFingerprint from "@/components/StorefrontFingerprint";

export default function StorefrontUnderConstruction({ config }) {
  const uc = config.under_construction || {};
  const info = config.store_info || {};
  const primary = config.branding?.primary_color || "#15803D";
  const secondary = config.branding?.secondary_color || "#B45309";
  const wa = info.whatsapp ? String(info.whatsapp).replace(/[^0-9]/g, "") : "";
  return (
    <div className="min-h-screen relative overflow-hidden" data-testid="under-construction-page" style={{ background: `radial-gradient(1200px 600px at 10% -10%, ${primary}22, transparent), radial-gradient(900px 500px at 110% 10%, ${secondary}22, #fafaf9)` }}>
      <StorefrontFingerprint />
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(#0f172a 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="relative max-w-xl mx-auto px-6 py-16 sm:py-24 text-center">
        {info.logo_url ? (
          <img src={mediaUrl(info.logo_url)} alt={info.name || "Store"} className="h-16 mx-auto object-contain mb-8" />
        ) : (
          <div className="w-16 h-16 mx-auto rounded-2xl text-white flex items-center justify-center font-display text-2xl font-bold mb-8" style={{ background: primary }}>
            {(info.name || "S").slice(0, 1).toUpperCase()}
          </div>
        )}
        <p className="text-xs tracking-[0.25em] uppercase font-semibold" style={{ color: primary }}>Coming soon</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-stone-900 mt-3 leading-tight">{uc.headline || "We're getting ready"}</h1>
        <p className="text-stone-600 mt-5 text-base sm:text-lg leading-relaxed">{uc.message}</p>
        {uc.eta ? <div className="mt-6 inline-flex px-4 py-2 rounded-full bg-white/80 border border-stone-200 text-sm font-medium text-stone-700">{uc.eta}</div> : null}
        {uc.show_whatsapp !== false && wa && (
          <div className="mt-10">
            <a
              href={`https://wa.me/${wa}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center h-12 px-6 rounded-full text-white font-semibold shadow-lg"
              style={{ background: primary }}
              data-testid="uc-whatsapp"
            >
              Chat on WhatsApp
            </a>
          </div>
        )}
        <p className="mt-16 text-xs text-stone-400">{info.name || "We'll be back shortly."}</p>
      </div>
    </div>
  );
}
